import * as React from "react";
import {firstOrDefault} from "../../utils";
import {Tab} from "../Tab/Tab";


export class Tabber extends React.Component<{}, { activeTabName?: string | null; tabs?: any[]}>{
    
    constructor(props) {
        super(props);
        this.getTabs = this.getTabs.bind(this);
        this.state = { activeTabName: null, tabs: [] };
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    getTabs(props) {
        let anyActive = false;
        let {activeTabName} = this.state;
        let mustSetActiveTab = !activeTabName;
        let tabs = React.Children.map(props.children, t => {
            let tab = React.cloneElement(t as any, (t as any).props) as any;
            if (tab['props'].isActive) {
                activeTabName = tab.props.name;
            }
            return tab;
        });
        
        if (!activeTabName && tabs && tabs.length > 0) {
            activeTabName = tabs[0].props.name;            
        }
        if (mustSetActiveTab) {
            this.setState({ activeTabName });
        }
        return tabs;
    }

    handleTabChange(selectedTab, event) {              
        this.setState({ activeTabName: selectedTab.props.name });
        event.preventDefault();
    }

    componentWillReceiveProps(props) {        
        this.setState({ tabs: this.getTabs(props) });
    }

    componentDidMount() {
        this.setState({ tabs: this.getTabs(this.props) });
    }

    render() {
        let {tabs, activeTabName} = this.state;

        if (!tabs || tabs.length === 0) {
            return (
                <div>No Tabs available</div>
            );
        }
        let activeTabElement = firstOrDefault(tabs.filter(tab => tab.props.name === activeTabName));
        return (
            <div>
                <div className="ksw__tabs ksw__tabs--navigation">
                    <ul role="tablist" className="ksw__tabs--list">
                        {tabs.map((tab, index) => {
                            let {props} = tab;

                            let classes = ['ksw__tabs--item'];
                            if (props.name === activeTabName) {
                                classes.push('is-active');
                            }
                            var boundClick = this.handleTabChange.bind(this, tab);
                            return (
                                <li key={props.name} role="tab" >
                                    {(() => {
                                        if (props.icon) {
                                            return (<span><i className={tab.icon}></i>&nbsp;</span>); 
                                        }
                                    }) ()}
                                    <a href="#" ref={props.name} onClick={boundClick} title={props.header}>{props.header}</a>
                                </li>
                            );
                        }) }
                    </ul>
                    <div>
                        {activeTabElement}
                    </div>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/Tabber/Tabber.tsx